<script setup>
// 导入暗色模式hook以确保在应用加载时初始化
import { useDarkMode } from './composables/useDarkMode';
import { defaultSEO } from './utils/seo';
import { useHead } from '@vueuse/head';
import { getCanonicalUrl } from './config/site';

// 初始化暗色模式
useDarkMode();

// 设置基础SEO标签
useHead({
  meta: [
    { charset: 'UTF-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    { name: 'description', content: defaultSEO.description },
    { name: 'keywords', content: defaultSEO.keywords },
    
    // Open Graph标签
    { property: 'og:title', content: defaultSEO.title },
    { property: 'og:description', content: defaultSEO.description },
    { property: 'og:type', content: defaultSEO.openGraph.type },
    { property: 'og:url', content: defaultSEO.openGraph.url },
    { property: 'og:site_name', content: defaultSEO.openGraph.siteName },
    { property: 'og:image', content: defaultSEO.openGraph.images[0].url },
    { property: 'og:image:width', content: defaultSEO.openGraph.images[0].width },
    { property: 'og:image:height', content: defaultSEO.openGraph.images[0].height },
    { property: 'og:image:alt', content: defaultSEO.openGraph.images[0].alt },
    
    // Twitter卡片标签
    { name: 'twitter:card', content: defaultSEO.twitter.cardType },
    { name: 'twitter:site', content: defaultSEO.twitter.site },
    { name: 'twitter:creator', content: defaultSEO.twitter.handle },
    { name: 'twitter:title', content: defaultSEO.title },
    { name: 'twitter:description', content: defaultSEO.description },
    { name: 'twitter:image', content: defaultSEO.openGraph.images[0].url },
    { name: 'twitter:image:alt', content: defaultSEO.openGraph.images[0].alt }
  ],
  // 默认规范链接，由各页面覆盖
  link: [
    { rel: 'canonical', href: getCanonicalUrl() }
  ]
});
</script>

<template>
  <router-view />
</template>

<style>
@import './style.css';
</style>
